<template>
  <div class="inner-html-toast" v-html="message"></div>
</template>

<script>
export default {
  name: 'inner-htnl-toast-v5',
  props:{
    message: String,
  }
}
</script>

<style lang="css">
  .inner-html-toast{
    font: inherit!important;
    color: inherit!important;
  }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/toast/InnerHtnlToastV5.vue